import {RcfaStoppageCode as StoppageCode} from '@domain/shared'
import {ApiClient} from '@hconnect/apiclient'
import {HttpError} from '@hconnect/common'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export type ResponseType = {
  currentPage: number
  data: Array<StoppageCode>
  totalCount: number
}

export const QueryKey = 'stoppage-search'

export const useSearchStoppageCodes = <TData = ResponseType,>(
  searchText?: string,
  options?: Omit<
    UseQueryOptions<ResponseType, AxiosError<HttpError>, TData>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery<ResponseType, AxiosError<HttpError>, TData>({
    queryKey: [QueryKey, searchText],
    queryFn: async () => {
      const path = '/rootcausefailureanalysis/stoppagecodes'
      return (await ApiClient.axiosInstance.post<ResponseType>(path, {params: {searchText}})).data
    },
    // these default values will get moved to the api provider soon
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,

    // allow the callee to override the default options
    ...options
  })
}
